"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordingController = void 0;
const analytics_1 = require("@streem/analytics");
const api_1 = require("@streem/api");
const toolbox_1 = require("@streem/toolbox");
const operators_1 = require("rxjs/operators");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const fetch_download_url_1 = require("../../util/fetch_download_url");
const logger_1 = require("../../util/logger");
const artifact_timed_deletion_1 = require("../../util/rx/artifact_timed_deletion");
const first_from_group_1 = require("../../util/rx/first_from_group");
const utils_1 = require("../wall/utils");
class RecordingController {
    constructor(config) {
        this.config = config;
        this.recordings = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('artifact'), (0, utils_1.accumulateAndTransformWallEvents)('artifact', (artifact) => __awaiter(this, void 0, void 0, function* () {
            if (artifact.artifactType !== streem_sdk_protobuf_1.WallItem.ArtifactType.RECORDING)
                return artifact;
            if (!artifact.recording)
                return artifact;
            (0, toolbox_1.invariant)(artifact.recording.storageUrl || artifact.recording.previewStorageUrl, 'Recording must have storage URL');
            const ready = artifact.status === streem_sdk_protobuf_1.WallItem.Artifact.Status.FULFILLED;
            if (!ready && artifact.recording.previewStorageUrl) {
                artifact.recording.previewDownloadUrl = yield (0, fetch_download_url_1.fetchDownloadUrl)(this.config.context.roomId, artifact.recording.previewStorageUrl);
            }
            else if (ready && artifact.recording.storageUrl) {
                artifact.recording.downloadUrl = yield (0, fetch_download_url_1.fetchDownloadUrl)(this.config.context.roomId, artifact.recording.storageUrl);
            }
            return artifact;
        })), (0, utils_1.filterByProperty)('artifactType', streem_sdk_protobuf_1.WallItem.ArtifactType.RECORDING), (0, operators_1.shareReplay)(1));
        this.recordingStatus = this.recordings.pipe((0, first_from_group_1.firstFromGroup)(), (0, operators_1.map)(recordingArtifact => { var _a; return (_a = recordingArtifact.recording.recordingStatus) !== null && _a !== void 0 ? _a : undefined; }));
    }
    getRecording(id) {
        return this.recordings.pipe((0, utils_1.filterByProperty)('id', id.toString()), (0, first_from_group_1.firstFromGroup)());
    }
    pauseRecording() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(this.config.context.roomId, 'Expected room id to be defined when pausing recording');
            try {
                yield api_1.StreemAPI.rooms.pauseRoomRecording(this.config.context.roomId.toString());
                logger_1.logger.info(`Room ${this.config.context.roomId.toString()} recording paused`);
            }
            catch (e) {
                throw new Error(`Failed to pause recording for room ${this.config.context.roomId}`, e);
            }
        });
    }
    resumeRecording() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(this.config.context.roomId, 'Expected room id to be defined when resuming recording');
            try {
                yield api_1.StreemAPI.rooms.resumeRoomRecording(this.config.context.roomId.toString());
                logger_1.logger.info(`Room ${this.config.context.roomId.toString()} recording resumed`);
            }
            catch (e) {
                throw new Error(`Failed to resume recording for room ${this.config.context.roomId}`, e);
            }
        });
    }
    /**
     * Deletes a recording off of the backend
     * @param id The recording id to delete
     */
    deleteRecording(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield api_1.StreemAPI.rooms.deleteRecording(this.config.context.roomId.toString(), id.toString());
                yield (0, artifact_timed_deletion_1.artifactTimedDeletion)(id.toString(), this.recordings);
                (0, analytics_1.recordArtifactDeleted)({
                    artifactSid: id.toString(),
                    roomSid: this.config.context.roomId.toString(),
                    recording: {},
                });
            }
            catch (e) {
                logger_1.logger.error('Failed to delete recording: ', id.toString());
            }
        });
    }
}
exports.RecordingController = RecordingController;
//# sourceMappingURL=recording_controller.js.map